class SellingPlansWidget {
  constructor(sellingPlansWidgetContainer) {
    this.sellingPlansWidgetContainer = sellingPlansWidgetContainer;
    this.hiddenClass = 'selling_plan_theme_integration--hidden';
    this.listenToVariantChange();
    this.listenToSellingPlanFormRadioButtonChange();
    this.updatePrice();
  }

  get variantIdInput() {
    return document.getElementById('current_variant_id');
  }

  get shopifySection() {
    return document.querySelector(`#shopify-section-${this.sellingPlansWidgetContainer.dataset.sectionId}`);
  }

  get visibleSellingPlanForm() {
    return this.shopifySection.querySelector(`section[data-variant-id="${this.variantIdInput.value}"]`);
  }

  get priceElement() {
    return this.shopifySection.querySelector('.price');
  }

  get salePriceElement() {
    return this.shopifySection.querySelector('.price__sale');
  }

  get selectedPurchaseOption() {
    return this.visibleSellingPlanForm?.querySelector('input[type="radio"]:checked');
  }

  listenToVariantChange() {
    const variantObserver = new MutationObserver(() => {
      this.handleVariantChange();
    });

    variantObserver.observe(this.variantIdInput, {
      attributes: true, // Watch for attribute changes (like value changes)
      attributeFilter: ['value'], // Only react to changes in the "value" attribute
    });
  }

  handleVariantChange() {
    this.updateSellingPlanFormVisibility();
    this.updatePrice();
    this.listenToSellingPlanFormRadioButtonChange();
  }

  updateSellingPlanFormVisibility() {
    const sellingPlanFormForSelectedVariant = this.shopifySection.querySelector(
      `section[data-variant-id="${this.variantIdInput.value}"]`
    );
    const sellingPlanFormsForUnselectedVariants = this.shopifySection.querySelectorAll(
      `.selling_plan_theme_integration:not([data-variant-id="${this.variantIdInput.value}"])`
    );
    
    this.showSellingPlanForm(sellingPlanFormForSelectedVariant);
    this.hideSellingPlanForms(sellingPlanFormsForUnselectedVariants);
  }

  showSellingPlanForm(form) {
    if (form) {
      form.classList.remove(this.hiddenClass);
    }
  }

  hideSellingPlanForms(forms) {
    forms.forEach((form) => {
      form.classList.add(this.hiddenClass);
    });
  }

  listenToSellingPlanFormRadioButtonChange() {
    const radioButtons = this.visibleSellingPlanForm?.querySelectorAll('input[type="radio"]');
    if (radioButtons) {
      radioButtons.forEach((radio) => {
        radio.addEventListener('change', (event) => {
          this.handleRadioButtonChange(event.target);
        });
      });
    }
  }

  handleRadioButtonChange(radioButton) {
    this.updatePrice();
  }

  updatePrice() {
    const selectedOption = this.selectedPurchaseOption;
    if (!selectedOption) return;

    const selectedPrice = selectedOption.dataset.variantPrice;
    const comparedAtPrice = selectedOption.dataset.variantCompareAtPrice;

    if (comparedAtPrice && comparedAtPrice !== selectedPrice) {
      this.showSalePrice(selectedPrice, comparedAtPrice);
    } else {
      this.showRegularPrice(selectedPrice);
    }
  }

  showSalePrice(price, comparedAtPrice) {
    this.salePriceElement.style.display = 'block';
    this.salePriceElement.querySelector('.price-item--sale').innerHTML = price;
    this.regularPriceElement.style.display = 'block';
    this.regularPriceElement.querySelector('.price-item--regular').innerHTML = comparedAtPrice;
    this.priceElement.classList.add('price--on-sale');
  }

  showRegularPrice(price) {
    this.regularPriceElement.style.display = 'block';
    this.regularPriceElement.querySelector('.price-item--regular').innerHTML = price;
    this.salePriceElement.style.display = 'none';
    this.priceElement.classList.remove('price--on-sale');
  }
}

document.querySelectorAll('.selling_plan_app_container').forEach((container) => {
  new SellingPlansWidget(container);
});
